// extracted by mini-css-extract-plugin
export var required = "_fx-0";